/* WJW 25 — legacy /search?q=... links should render the same product-only
 * results as the approved mobile search page; preserve filters/sort/query. */
(() => {
  'use strict';
  if (!document.body?.classList.contains('template-search')) return;
  const url = new URL(window.location.href);
  if (!url.searchParams.has('q')) return;
  const type = url.searchParams.get('type');
  if (type !== 'product') {
    url.searchParams.set('type','product');
    window.location.replace(url.toString());
  }
})();
